import React from 'react'

const CoachingTrainingIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='22'
    height='19'
    viewBox='0 0 22 19'
    fill='none'
    {...props}
  >
    <path
      d='M11 18.5L4 14.7V8.7L0 6.5L11 0.5L22 6.5V14.5H20V7.6L18 8.7V14.7L11 18.5ZM11 10.2L17.85 6.5L11 2.8L4.15 6.5L11 10.2ZM11 16.225L16 13.525V9.75L11 12.5L6 9.75V13.525L11 16.225Z'
      fill='currentcolor'
    />
  </svg>
)

export default CoachingTrainingIcon
